import {useCallback} from 'react';
import {useOverallInfo} from '@components/_context';
import {AccountApplication} from '@application/Account';

export const useUpdateNextOrderDate = (orderId: string): {updateNextOrderDate: (date: string) => Promise<void>} => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const {updateOrder, updateNextBoxDate, updateEstimatedCarrierDeliveryAt} = useOverallInfo() as any;

  const updateNextOrderDate = useCallback(
    async (date: string) => {
      await AccountApplication.updateNextOrderDate(date);
      await updateOrder({id: orderId, nextBoxDate: date});
      updateNextBoxDate(date);
      updateEstimatedCarrierDeliveryAt(date);
    },
    [orderId, updateOrder, updateNextBoxDate, updateEstimatedCarrierDeliveryAt],
  );

  return {updateNextOrderDate};
};
